<template>
  <div>
    <el-dialog
      class="form-modal"
      :visible.sync="visible"
      :fullscreen="true"
      :show-close="false"
      :modal="false"
    >
      <div class="modal-header">
        <div class="modal-header-layout flex grid-6 align-center">
          <h1 class="modal-title col-2">
            Phone Numbers in Campaign: {{ recordId }}
          </h1>
          <div class="modal-actions col-2">
            <el-button type="default" @click="handleClose">Close</el-button>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-center pt-20">
        <div id="tcr-numbers-table" class="vxe-table-height table-width card-base card-shadow--medium">
          <vxe-grid
            round
            border="inner"
            ref="xGrid"
            height="100%"
            auto-resize
            empty-text="No Data"
            highlight-hover-row
            show-overflow="tooltip"
            @cell-mouseenter="rowHover"
            @cell-mouseleave="rowLeave"
            :data="tableData"
            :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
            :sort-config="{
              defaultSort: { field: 'provisionedDate', order: 'desc' },
            }"
            :loading="tableLoading"
            :columns="tableColumns"
          />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { globalEventBus } from "@/globalEventBus";
import { apiV2Host } from "@/feathers/feathers-client";
import { phoneNumberFormatter } from "@/globals/globals";

export default {
  name: "UsersTable",
  props: {
    recordId: { default: "" },
    visible: { default: false },
  },
  data() {
    return {
      tableData: [],
      visibleActionsId: "",
      tableLoading: true,
      tableColumns: [
        {
          field: "order",
          sortable: false,
          title: "",
          width: 50,
          type: "seq"
        },
        {
          field: "phoneNumber",
          title: "Phone Number",
          sortable: true,
          showOverflow: false,
          width: 250,
          slots: {
            default: ({ row }) => {
              return [<span>{phoneNumberFormatter(row.phoneNumber)}</span>];
            },
          },
        },
        {
          field: "provisionedDate",
          title: "Provisioned Date",
          sortable: true,
          minWidth: 250,
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <span>
                  {row.provisionedDate
                    ? moment(row.provisionedDate).format("M/DD/YY")
                    : "N/A"}
                </span>,
              ];
            },
          },
        },
        {
          field: "actions",
          title: "",
          minWidth: 150,
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div v-show={row.phoneNumber === this.visibleActionsId}>
                  <el-tooltip placement="top" content="Remove">
                    <el-button
                      id={"delete-" + row.id}
                      icon="el-icon-delete"
                      onClick={() =>
                        this.deprovisionNumberFromCampaign(row.phoneNumber)
                      }
                      class="table-action-button icon-red"
                      style="width: 20px; height: 20px;"
                    />
                  </el-tooltip>
                </div>,
              ];
            },
          },
        },
      ],
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
  },
  watch: {
    recordId() {
      this.queryPhoneNumbersInCampaign();
    },
  },
  methods: {
    async queryPhoneNumbersInCampaign() {
      if (!this.recordId) {
        return;
      }

      try {
        const res = await fetch(
          `${apiV2Host}/admin/tcr/campaigns/phone-numbers/${this.recordId}`,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + this.$store.state.auth.accessToken,
            },
          }
        );

        if (!res.ok) {
          throw new Error("There was an error retrieving your brand data!");
        }

        const values = await res.json();
        this.tableData = values.records || [];
        this.tableLoading = false;
      } catch (_e) {
        //
        this.tableLoading = false;
      }
    },
    async deprovisionNumberFromCampaign(phoneNumber) {
      try {
        const body = {
          enabled: 0,
          number: this.removeLeadingOne(phoneNumber),
        };

        this.tableLoading = true;

        const res = await fetch(`${apiV2Host}/admin/phone-numbers/sms/provision`, {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            Authorization: "Bearer " + this.$store.state.auth.accessToken,
            "Content-Type": "application/json",
          },
        });

        if (!res.ok) {
          throw new Error("There was an error retrieving your brand data!");
        }

        this.tableLoading = false;
      } catch (_e) {
        //
        this.tableLoading = false;
      }
    },

    rowHover(data) {
      this.visibleActionsId = data.row.phoneNumber;
    },
    rowLeave() {
      this.visibleActionsId = "";
    },
    removeListeners() {
      globalEventBus.$off("appReconnected");
    },

    handleModalClose() {
      this.modalVisible = false;
      this.modalContext = "";

      // refresh the campaign list
      this.queryCampaigns();
    },

    handleCloseModal() {
      this.brandFeedbackVisible = false;
    },
    timeFormatter(time) {
      return moment(time).format("M/DD/YY");
    },
    removeLeadingOne(phoneNumber) {
      if (phoneNumber.charAt(0) === "1") {
        return phoneNumber.substring(1);
      } else {
        return phoneNumber;
      }
    },
    handleClose() {
      this.$emit("modalClosed");
      this.tableData = [];
      this.tableLoading = true;
    },
  },
  mounted() {
    if (this.user) {
      this.queryPhoneNumbersInCampaign();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variables";

.table-width {
  width: 800px;
}

table.styled {
  .peity {
    margin-right: 10px;
  }
}

tr.vxe-body--row {
  height: 40px !important;
}

#numbers-table tr {
  height: 40px !important;
}
</style>
